import * as Telecom from '@servicetitan/telecom-rtcs-client';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import appManager from '@app/appManager';
import {
  ServiceSessionEventType,
  ServiceSessionUserEvent,
} from '../../types/ServiceEvents';
import requireUser from '../../lib/requireUser';
import log from '../../lib/log';
import { setUserStatus } from '../../lib/userStatus';
import { serviceState } from '../../lib/state';
import isValidUser from '../../lib/isValidUser';
import { EventAvailabilityState } from '../../lib/eventAvailabilityState';
import {
  ServiceUserUtils,
  userStatsLastActionTimeFix,
} from '../../lib/serviceUserUtils';
import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import { RTCSEventType } from '../../../metrics/rtcsMetrics';
import { trackRTCSEventLatency } from '../../lib/trackRTCSEventLatency';

/**
 * The delivered event indicates that a session was successfully
 * delivered to a recipient and is now being handled.
 * @param event
 */
async function handleAgentSessionDelivered(
  event: Telecom.AgentSessionDeliveredEvent,
) {
  trackRTCSEventLatency(event.timestamp, RTCSEventType.SESSION_DELIVERED);

  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:session_delivered:' + user?.name, event);

  user.stats = userStatsFromAgentStats(event.stats);

  userStatsLastActionTimeFix({ user, timestamp: event.timestamp });

  // update our status. can't change status while offered a call
  setUserStatus({
    userId: user.id,
    status: event.available ? UserSetAvailabilityStatus.Available : undefined,
  });
  ServiceUserUtils.setEventActivityStatus(user, EventAvailabilityState.OnACall);

  appManager.events.emit<ServiceSessionUserEvent>(
    ServiceSessionEventType.DELIVERED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      agentId: event.agentId,
      userId: user.id,
    },
  );

  const session = serviceState.sessions[event.conversationId];
  if (!session) {
    console.error('session not found', event.conversationId);
    return;
  }

  session.agentId = event.agentId;
  session.createdAt = Date.now();
  session.queueId = event.queueId;
  session.queueName = event.queueName;
}

export default handleAgentSessionDelivered;
